import { render } from "./SiteMapComponent.vue?vue&type=template&id=1c39c6a2"
import script from "./SiteMapComponent.vue?vue&type=script&lang=js"
export * from "./SiteMapComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kreigdurham/Documents/Git/af3-shortcodes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__